<template>
    <section>
        <div class="pro_section1" style="display: flex; flex-direction: column; justify-content: flex-end; position: relative; ">
            <div class="con_wrap" style="height: 60%; display: flex; flex-direction: column; align-items: flex-start; justify-content: flex-end;">
                <p data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="font-size: 50px; font-weight: 300; color: white; text-align: left; color: #E4E4E4; margin-bottom: 82px;">
                    교육 시장의 불평등을 해소하는<br>
                    사회적 가치를 만듭니다
                </p>
                <div style="height: 68px"></div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon
    }

}
</script>
<style>
    .pro_section1 {
        width: 100vw;
        height: 100vh;
        background: url('../../../../../../assets/images/main_v2/background_section3.svg') no-repeat;
        object-fit: inherit;
    }
</style>
